// src/app/guards/role.guard.ts
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthserviceService } from '../@core/services/authservice.service';
import { AlertMessage, ServiceService } from '../@core/services/service.service';


export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthserviceService);
  const router = inject(Router);
  const service = inject(ServiceService);

  const expectedRoles: string[] = route.data['roles'];
  const user = authService.usuarioValue;

  if (user && (user.roles ?? []).some(role => expectedRoles.includes(role))) {
    return true;
  }

  // Mostrar alerta si no tiene permiso
  const alert: AlertMessage = {
    type: 'error',
    summary: 'Acceso denegado',
    detail: 'No tienes permisos para acceder a esta sección.'
  };
  service.showAlert(alert);

  // Redirigir a una ruta permitida
  return router.parseUrl('/farmacias');
};
